import { BreadcrumbLinkClickPayload } from '@noths/polaris-client-next-components';
import { createAction } from '@reduxjs/toolkit';

export const breadcrumbLinkClick = createAction<BreadcrumbLinkClickPayload>('breadcrumb/linkClick');
